<template>
  <div class="earlySummer">
    <div><img class="bg" src="https://cms.dafang24.com/aliapp/page/20210513/es_bg_01.png"></div>
    <div class="btnsBox">
      <img class="bg" src="https://cms.dafang24.com/aliapp/page/20210513/es_bg_02.png">
      <a href="javascript:void(0);" class="btn btn04" @click="getActivityDiscount"></a>
    </div>
    <div><img class="bg" src="https://cms.dafang24.com/aliapp/page/20210513/es_bg_03.png"></div>
    <!-- 错误信息 -->
    <div class="noLogin"><span></span></div>
  </div>
</template>

<script>
  import { orderSource } from "@/utils/env";
  import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
  export default {
    name: "earlySummer",
    data () {
      return {
        couponList: [ //领券列表
          {
            name: "连续租满7天立减280元，节假日不可用",
            OfferID: 475
          },
          {
            name: "连续租满4天立减160元，节假日不可用",
            OfferID: 474
          },
          {
            name: "连续租满2天立减80元，节假日不可用",
            OfferID: 473
          }
        ]
      }
    },
    created() {
    },
    methods: {
      getActivityDiscount(type=0){
        if( localStorage.getItem('token') ){
          let couponList = this.couponList;
          if(type==1) { couponList = new Array( this.couponList[0] ); }
          if(type==2) { couponList = new Array( this.couponList[1] ); }
          if(type==3) { couponList = new Array( this.couponList[2] ); }
          this.consumerCouponsFn(couponList);
        } else {
          this.flexible.showToast({
            content:'请先登陆/注册！',
            success: ()=>{
              if( orderSource==17 ){
                window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
              } else if ( orderSource==16 ){
                dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
              }
            }
          });
        }
      },
      goHome () {
        if( orderSource==17 ){
          window.webkit.messageHandlers.goHome.postMessage(null);
        } else if ( orderSource==16 ){
          dfpanda.goHome();
        }
      },
      async consumerCouponsFn (copList) { // 获取用户优惠券
        let res = await getConsumerCoupons();
        if( res.Code==100 ){
          let uCoupon = res.Data || [];
          if( uCoupon.length ){
            for( let i in uCoupon ){
              for( let j in copList ){
                if( uCoupon[i].OfferID == copList[j].OfferID ){
                  copList.splice(j, 1)
                }
              }
            }
          }
          console.log(copList);
          if( copList.length ){
            let lastRes = false;
            for( let item of copList ){
              let gRes = await this.getDrawCoupon(item.OfferID);
              if( gRes ){ lastRes = gRes }
            }
            if( lastRes ){
              this.flexible.showToast({
                duration:1200,
                content:'领取成功！去租车',
                success:()=>{
                  this.goHome()
                }
              });
            } else {
              this.flexible.showToast({content:'领取失败，请重试'})
            }
          } else {
            this.flexible.showToast({
              duration:1200,
              content:'领取成功！去租车',
              success:()=>{
                this.goHome()
              }
            })
          }
        }
      },
      async getDrawCoupon ( offerID ) {
        let res = await DrawCoupon({
          data: {
            OfferID: offerID,
            orgID: 0
          },
          isLoading: 1,
          loadContent: '获取优惠券...'
        });
        if( res.Code==100 ){
          return true;
        }
        return false;
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  .earlySummer {
    width: 100%;
    .bg { width: 100%; }
    .btnsBox {
      position: relative;
      .btn { display: block; position: absolute; }
      .btn04 { width: 410px; height: 130px; left: 23%; top: 630px; }
    }
  }
</style>